  document.addEventListener("DOMContentLoaded", () => {
        function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }
      
        document.querySelectorAll("[data-scroll]").forEach(root => {

            console.log("Found one");
            

          const viewport = root.querySelector("[data-scroll-viewport]");
          const bar = root.querySelector("[data-cscroll-bar]");
          const thumb = root.querySelector("[data-cscroll-thumb]");
          if(!viewport || !bar || !thumb) return;
      
          let dragging = false;
          let dragStartY = 0;
          let dragStartScrollTop = 0;
      
          function update(){
            const scrollH = viewport.scrollHeight;
            const clientH = viewport.clientHeight;
      
            const scrollable = scrollH > clientH + 1;
            root.classList.toggle("is-scrollable", scrollable);
      
            // If bar has no height, thumb can't move—bail safely
            const trackH = bar.getBoundingClientRect().height;
            if(!scrollable || trackH <= 1) return;
      
            const thumbH = clamp((clientH / scrollH) * trackH, 18, trackH);
            thumb.style.height = thumbH + "px";
      
            const maxScroll = scrollH - clientH;
            const maxThumbY = trackH - thumbH;
      
            const ratio = maxScroll ? (viewport.scrollTop / maxScroll) : 0;
            thumb.style.transform = `translateY(${ratio * maxThumbY}px)`;
          }
      
          // keep thumb synced while scrolling
          viewport.addEventListener("scroll", update, { passive: true });
          window.addEventListener("resize", update);
      
          // drag thumb
          thumb.addEventListener("pointerdown", (e) => {
            if(e.button !== undefined && e.button !== 0) return;
            dragging = true;
            thumb.setPointerCapture?.(e.pointerId);
            dragStartY = e.clientY;
            dragStartScrollTop = viewport.scrollTop;
            e.preventDefault();
          });
      
          window.addEventListener("pointermove", (e) => {
            if(!dragging) return;
      
            const scrollH = viewport.scrollHeight;
            const clientH = viewport.clientHeight;
            const trackH = bar.getBoundingClientRect().height;
            const thumbH = thumb.getBoundingClientRect().height;
      
            const maxScroll = scrollH - clientH;
            const maxThumbY = trackH - thumbH;
      
            const dy = e.clientY - dragStartY;
            const scrollDelta = maxThumbY ? (dy / maxThumbY) * maxScroll : 0;
      
            viewport.scrollTop = dragStartScrollTop + scrollDelta;
          });
      
          window.addEventListener("pointerup", () => { dragging = false; });
      
          // click on track to jump
          bar.addEventListener("pointerdown", (e) => {
            if(e.target === thumb) return;
      
            const rect = bar.getBoundingClientRect();
            const clickY = e.clientY - rect.top;
      
            const scrollH = viewport.scrollHeight;
            const clientH = viewport.clientHeight;
            const trackH = rect.height;
            const thumbH = thumb.getBoundingClientRect().height;
      
            const maxScroll = scrollH - clientH;
            const maxThumbY = trackH - thumbH;
      
            const targetThumbY = clamp(clickY - thumbH/2, 0, maxThumbY);
            const ratio = maxThumbY ? (targetThumbY / maxThumbY) : 0;
      
            viewport.scrollTop = ratio * maxScroll;
          });
      
          // observe size/content changes
          const ro = new ResizeObserver(update);
          ro.observe(root);
          ro.observe(viewport);
      
          const mo = new MutationObserver(update);
          mo.observe(viewport, { childList:true, subtree:true, characterData:true });
      
          // initial paint
          update();
          requestAnimationFrame(update); // helps when fonts/images load after first layout
        });
      });